// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__u5dvE","header__wrapper":"Header_header__wrapper__54xPJ","spin":"Header_spin__2otuA","loader":"Header_loader__vSsG_"};